import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter } from '@angular/material/core';
import { HealthCheckService } from './health-check.service';
import { APP_INITIALIZER } from '@angular/core';
import {NgxEchartsModule} from 'ngx-echarts';
export interface MyAppConfig extends ApplicationConfig {
  columnOptions: string[];
  communicationType: { key: string; value: string }[];
  emDataPushRate: { key: string; value: string }[];
}
export function initializeApp(healthCheckService: HealthCheckService) {
  return () => healthCheckService.checkBackendAvailability()
    .then(success => {
      if (!success) {
        window.location.href = '/assets/static-page.html';
      }
    });
}
export const appConfig: MyAppConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,withHashLocation()),
    provideHttpClient(),
    provideClientHydration(),
    provideToastr({}),
    provideAnimations(),
    provideNativeDateAdapter(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [HealthCheckService],
      multi: true
    },
    ...NgxEchartsModule.forRoot({ echarts: () => import('echarts') }).providers,
  ],
  columnOptions: [
    '3ph_R_V1',
    '3ph_Y_V2',
    '3ph_B_V3',
    '3phV_Average',
    '3phV_V12',
    '3phV_V23',
    '3phV_V31',
    '3phCurr_L1',
    '3phCurr_L2',
    '3phCurr_L3',
    '3phCurr_LN',
    'PowerFactor_Q1',
    'PowerFactor_Q2',
    'PowerFactor_Q3',
    '3phPowerW1',
    '3phPowerW2',
    '3phPowerW3',
    'PowerFactor_average',
    'Frequency',
    'THDV1_R',
    'THDV2_Y',
    'THDV3_B',
    'THDC1_R',
    'THDC2_Y',
    'THDC3_B',
    'EnergyConsumption_Import',
    'EnergyConsumption_Export',
    'EnergyConsumption_Net',
    'ApparentActiveImport',
    'ApparentActiveExport',
    'ReactiveImport',
    'ReactiveExport',
    'ActiveForwarded',
    'ApparentForwarded',
    'ReactiveLagForwarded',
    'ReactiveLeadForwarded',
    'ActiveGrossImport',
    'ActiveGrossExport',
    'ActivePowerPeakDemand_W',
    'ReactivePowerPeakDemand_VA'
  ],
  communicationType: [
    { key: 'Modbus-rtu', value: 'Modbus-rtu' },
    { key: 'mqtt', value: 'mqtt' }
  ],
  emDataPushRate: [
    { key: '5', value: '5' },
    { key: '10', value: '10' },
    { key: '15', value: '15' },
  ]
};
